<template>
  <v-dialog
      v-model="closePopup"
      max-width="500"
      persistent
      content-class="customize-dialog"
    >
      <v-card class="pa-4">
        <v-card-title class="text-h6 font-weight-600 px-4">
          <span class="secondary--font text-capitalize"> Close Ticket </span>
        </v-card-title>
        <v-card-text
          class="body-2 px-4"
          v-if="selectedTicketsData.length === 1"
        >
          <p>Are you sure you want to close the selected ticket?</p>
          
        </v-card-text>

        <v-card-text class="body-2 px-4" v-else>
          <p v-if="checkSelectedClosedTicket.length > 0">
            {{ checkSelectedClosedTicket.length }} 
            Selected ticket
            {{
              checkSelectedClosedTicket.length > 1 ? "s" : ""
            }}
            are already marked as closed and will be ignored.
          </p>
          <p v-else>
            Are you sure you want to close selected
            {{ checkSelectedTicket > 1 ? checkSelectedTicket : "" }}
            ticket{{ checkSelectedTicket > 1 ? "s" : "" }}?
          </p>
          <b class="pt-10">
            Note : Close reason will be set to Resolved, to make any changes
            please update the tickets individually.
          </b>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closePopup = false" class="font-weight-bold"
           v-track="'cancel-close-ticket-action'">
            Cancel
          </v-btn>
          <v-btn dark @click="confirmClose" class="font-weight-bold"
           v-track="'confirm-close-ticket-action'">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
  name: "CloseTicketDialog",
  props: {
    selectedTicketsData: {
      type: Array,
      default:()=>[]
    },
    checkSelectedTicket: {
      type: Number,
      default: 0
    },
    closeDialog: {
      type: Boolean,
      deafult: false
    }
  },
  computed: {
    closePopup: {
      get() {
        return this.closeDialog
      },
      set(val) {
        this.$emit('updateDialog', val)
      }
    },
    checkSelectedClosedTicket() {
      let closedTicket = [];
      this.selectedTicketsData.forEach((item) => {
        if (item.status === "closed") {
          closedTicket.push(item);
        }
      });
      return closedTicket;
    },
  },
  methods: {
    confirmClose() {
      this.$emit('confirmClose')
    }
  }
}
</script>